import { render } from "./CompanySettingView.vue?vue&type=template&id=04c50944"
import script from "./CompanySettingView.vue?vue&type=script&lang=js"
export * from "./CompanySettingView.vue?vue&type=script&lang=js"

import "./CompanySettingView.vue?vue&type=style&index=0&id=04c50944&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__